var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinUsing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pin-using",
    transform: "translate(-0.081 0.153)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 48,
    height: 48,
    transform: "translate(0.081 -0.153)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    transform: "translate(0.081 26.847)",
    fill: "#0ff497",
    stroke: "#414143",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 18,
    rx: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 0.6,
    width: 46.8,
    height: 16.8,
    rx: 8.4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Title",
    transform: "translate(7.081 27.847)",
    fill: "#414143",
    fontSize: 11,
    fontFamily: "PingFangTC-Semibold, PingFang TC",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "\u4F7F\u7528\u4E2D")), /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M27.458,25.706a8.97,8.97,0,0,0,3.882-5.918,8.865,8.865,0,0,0,.111-1.4c0-6.316-6.687-11.436-14.937-11.436S1.576,12.075,1.576,18.391a8.794,8.794,0,0,0,4.615,7.763c2.182,1.249,5.5,2.411,10.73,2.411,5.4,0,8.247-1.292,10.537-2.859",
    transform: "translate(7.47 -0.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M16.514,6.955c8.25,0,14.938,5.12,14.938,11.435a8.868,8.868,0,0,1-.111,1.4,8.972,8.972,0,0,1-3.883,5.918c-2.289,1.567-5.133,2.859-10.536,2.859-5.23,0-8.549-1.162-10.731-2.411A8.8,8.8,0,0,1,1.576,18.39c0-6.315,6.688-11.435,14.938-11.435m0-1.2C7.615,5.755.376,11.423.376,18.39a10.154,10.154,0,0,0,.717,3.74,10.274,10.274,0,0,0,4.5,5.066,22.665,22.665,0,0,0,11.327,2.569c5.932,0,9-1.552,11.214-3.069a10.21,10.21,0,0,0,4.39-6.719,10.038,10.038,0,0,0,.126-1.587c0-6.967-7.24-12.635-16.138-12.635",
    transform: "translate(7.47 -0.153)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M17.664,14.472c4.809.36,8.765.52,11.436.591a14.764,14.764,0,0,1,1.9.543,10.792,10.792,0,0,0-3.152-4.656c-1.46,0-2.584.1-2.584.1a85.08,85.08,0,0,1-17.33.05S6.69,10.991,5.118,11a10.728,10.728,0,0,0-3.132,4.728c.415-.159.86-.31,1.337-.444,1.211-.028,2.777-.126,4.8-.346,0,0,7.113-.649,9.545-.467",
    transform: "translate(7.47 -0.153)",
    fill: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M15.64,9.839a.345.345,0,0,1-.207-.062.178.178,0,0,1-.085-.149V5.593a.18.18,0,0,1,.085-.149.345.345,0,0,1,.207-.061h1.875a5.828,5.828,0,0,1,.969.073,3.016,3.016,0,0,1,.783.237,1.3,1.3,0,0,1,.544.453,1.291,1.291,0,0,1,0,1.371,1.455,1.455,0,0,1-.54.48,2.913,2.913,0,0,1-.775.272,4.606,4.606,0,0,1-.937.09h-.681c-.027,0-.041.01-.041.03V9.628a.181.181,0,0,1-.081.149.327.327,0,0,1-.2.062Zm1.193-2.351c0,.02.014.029.041.029h.608q1.071,0,1.071-.684a.48.48,0,0,0-.276-.465,1.96,1.96,0,0,0-.835-.137h-.568c-.027,0-.041.008-.041.023Z",
    transform: "translate(7.47 -0.153)",
    fill: "#07df80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M16.82,23.347a4.487,4.487,0,0,1-3.005-1.184.6.6,0,0,1,.861-.836c.083.085,1.886,1.844,4.573-.069a.6.6,0,1,1,.7.977,5.346,5.346,0,0,1-3.125,1.112",
    transform: "translate(7.47 -0.153)",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M13.115,21h-.5a.34.34,0,0,1-.34-.34V18.73a.34.34,0,0,1,.34-.34h.5a.34.34,0,0,1,.34.34v1.935a.34.34,0,0,1-.34.34",
    transform: "translate(7.47 -0.153)",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "M21.048,21h-.5a.34.34,0,0,1-.34-.34V18.73a.34.34,0,0,1,.34-.34h.5a.34.34,0,0,1,.34.34v1.935a.34.34,0,0,1-.34.34",
    transform: "translate(7.47 -0.153)",
    fill: "#414143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M29.76,10.45c0-3.292,1.778-7.168-8.047-8.852A24.859,24.859,0,0,0,5.244,4.124c-3.276,1.685-1.739,6.234-1.739,6.234L16.11,11.907Z",
    transform: "translate(7.47 -0.153)",
    fill: "#00f288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M17.081,1.2a27.372,27.372,0,0,1,4.632.4c9.825,1.684,8.047,5.56,8.047,8.852L16.11,11.907,3.505,10.358S1.968,5.809,5.244,4.124A23.752,23.752,0,0,1,17.081,1.2m0-1.2A24.979,24.979,0,0,0,4.65,3.081C1.381,4.8,1.725,8.839,2.368,10.742a1.2,1.2,0,0,0,.991.807l12.6,1.55a1.448,1.448,0,0,0,.147.008c.042,0,.085,0,.127-.006l13.65-1.458A1.2,1.2,0,0,0,30.96,10.45c0-.392.029-.8.059-1.242.21-3.016.5-7.147-9.1-8.793A28.725,28.725,0,0,0,17.081,0",
    transform: "translate(7.47 -0.153)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M17.564,13.2a78.75,78.75,0,0,0-8.57.468,27.592,27.592,0,0,1-6.979.231,1.574,1.574,0,0,1-1.206-.944C-.946,8.844,8.83,9.832,8.83,9.832a68.567,68.567,0,0,0,15.56-.05s9.777-.989,8.021,3.123a1.577,1.577,0,0,1-1.2.945s-5.462.033-13.642-.649",
    transform: "translate(7.47 -0.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M4.028,14.624a14.15,14.15,0,0,1-2.1-.13,2.164,2.164,0,0,1-1.668-1.3A2.3,2.3,0,0,1,.4,10.8C2.015,8.608,8.192,9.165,8.892,9.236a68.717,68.717,0,0,0,15.429-.05c.708-.073,6.885-.63,8.5,1.565a2.293,2.293,0,0,1,.145,2.389,2.162,2.162,0,0,1-1.666,1.3c-.141.009-5.67.031-13.783-.644a80.562,80.562,0,0,0-8.46.466,42.362,42.362,0,0,1-5.027.359m2.5-4.3c-2.142,0-4.495.289-5.157,1.19-.142.194-.3.53-.008,1.208a.971.971,0,0,0,.745.588,27.149,27.149,0,0,0,6.816-.235,77.615,77.615,0,0,1,8.691-.47c8.061.672,13.539.652,13.589.648a.979.979,0,0,0,.657-.581c.29-.679.134-1.015-.008-1.208-.911-1.24-5.025-1.322-7.4-1.083a69.936,69.936,0,0,1-15.7.048c-.644-.065-1.419-.105-2.223-.105",
    transform: "translate(7.47 -0.153)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "M15.112,9.11a.29.29,0,0,1-.173-.051.151.151,0,0,1-.071-.125V5.559a.153.153,0,0,1,.071-.125.29.29,0,0,1,.173-.051H16.68a4.988,4.988,0,0,1,.811.061,2.536,2.536,0,0,1,.655.2,1.1,1.1,0,0,1,.455.379,1.082,1.082,0,0,1,0,1.147,1.225,1.225,0,0,1-.452.4A2.45,2.45,0,0,1,17.5,7.8a3.8,3.8,0,0,1-.784.076h-.57c-.023,0-.034.008-.034.024V8.934a.153.153,0,0,1-.068.125.275.275,0,0,1-.17.051Zm1-1.966c0,.016.011.024.034.024h.509q.9,0,.9-.572a.4.4,0,0,0-.231-.389,1.643,1.643,0,0,0-.7-.115h-.475c-.023,0-.034.007-.034.02Z",
    transform: "translate(7.47 -0.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    d: "M16.68,5.383a4.879,4.879,0,0,1,.811.061,2.548,2.548,0,0,1,.655.2,1.1,1.1,0,0,1,.455.379,1.079,1.079,0,0,1,0,1.147,1.2,1.2,0,0,1-.451.4A2.451,2.451,0,0,1,17.5,7.8a3.877,3.877,0,0,1-.784.076h-.57c-.023,0-.034.008-.034.024V8.934a.154.154,0,0,1-.068.125.275.275,0,0,1-.17.051h-.76a.29.29,0,0,1-.173-.051.153.153,0,0,1-.071-.125V5.559a.153.153,0,0,1,.071-.125.29.29,0,0,1,.173-.051Zm-.536,1.785h.509q.9,0,.9-.572a.4.4,0,0,0-.231-.389,1.643,1.643,0,0,0-.7-.115h-.475c-.023,0-.034.007-.034.02V7.144c0,.016.011.024.034.024m.536-2.785H15.112a1.286,1.286,0,0,0-.757.24,1.145,1.145,0,0,0-.487.936V8.934a1.146,1.146,0,0,0,.486.936,1.287,1.287,0,0,0,.758.24h.76a1.272,1.272,0,0,0,.774-.254,1.152,1.152,0,0,0,.464-.922V8.858a4.589,4.589,0,0,0,.592-.082,3.457,3.457,0,0,0,.914-.324,2.214,2.214,0,0,0,.814-.729,2.079,2.079,0,0,0,0-2.26,2.077,2.077,0,0,0-.859-.726,3.559,3.559,0,0,0-.914-.279,5.9,5.9,0,0,0-.977-.075",
    transform: "translate(7.47 -0.153)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinUsing);
export default __webpack_public_path__ + "static/media/pin-using.d0383df3364e523fdec1e9c9b0a64053.svg";
export { ForwardRef as ReactComponent };